export default __webpack_public_path__ + "static/media/speed-map-mobile.9a6eca98.png";